<app-layout>
  <!-- ===== TABS ===== -->
  <div class="tab-nav">
    <button
      class="tab-btn"
      [class.active]="activeTab === 'browse'"
      (click)="setBrowseTab()"
    >
      Browse Customers
    </button>

    <button
      class="tab-btn"
      [class.active]="activeTab === 'search'"
      (click)="setSearchTab()"
    >
      Non-Territory Search
    </button>
  </div>

  <!-- ===== MAIN CONTENT ===== -->
  <div class="page-content">
    <!-- ================= BROWSE TAB ================= -->
    <ng-container *ngIf="activeTab === 'browse'">
      <!-- ===== FILTERS ===== -->
      <div class="filters-panel">
        <div class="container filter-container">
          <form [formGroup]="filterForm">
            <div class="filter-row-horizontal">
              <!-- District -->
              <div class="filter-row">
                <label class="filter-label">District</label>
                <mat-form-field appearance="outline" class="filter-field">
                  <mat-select formControlName="district">
                    <mat-option *ngFor="let district of districtList" [value]="district">
                      {{ district }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Territory -->
              <div class="filter-row">
                <label class="filter-label">Territory</label>
                <mat-form-field appearance="outline" class="filter-field">
                  <mat-select formControlName="territory">
                    <mat-option *ngFor="let territory of filteredTerritories" [value]="territory.territoryId">
                      {{ territory.territoryId }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- ===== SEARCH + RESULTS ===== -->
      <div class="results-section">
        <!-- <div *ngIf="isBusy" class="customer-loading-overlay">
          <mat-spinner diameter="60"></mat-spinner>
        </div> -->
        <app-spinner *ngIf="isBusy" [isbusy]="isBusy"></app-spinner>

        <!-- ✅ SINGLE CONTAINER FOR BOTH -->
        <div class="search-wrapper container" [formGroup]="filterForm">
          <!-- Loading Spinner -->

          <!-- ===== SEARCH ===== -->
          <div class="search-title">Search Customers</div>

          <div class="search-and-toggle">
            <mat-form-field appearance="outline" class="search-field">
              <mat-icon matPrefix>search</mat-icon>
              <input
                class="placeholder-text"
                matInput
                formControlName="searchTerm"
                placeholder="Customer Name, Ship to, Sold to"
              />
            </mat-form-field>

            <div class="view-toggle">
              <button
                type="button"
                class="toggle-btn grid-btn"
                [class.active]="viewMode === 'grid'"
                (click)="viewMode = 'grid'"
              >
                <img src="assets/newimages/Listicon.png">
              </button>

              <button
                type="button"
                class="toggle-btn list-btn"
                [class.active]="viewMode === 'list'"
                (click)="viewMode = 'list'"
              >
                <img src="assets/newimages/gridicon.png">
              </button>
            </div>
          </div>

          <!-- ===== GRID VIEW (✅ MOVED INSIDE SAME CONTAINER) ===== -->
          <div class="customers-scroll" *ngIf="viewMode === 'grid'">
            <div class="customers-grid" *ngIf="pagedData?.length > 0">
              <div *ngFor="let customer of pagedData" class="grid-view">
                <div class="card-header">
                  <span class="customer-company">{{ customer.orders?.length ? customer.orders[0].shipToName : '' }}</span>
                </div>

                <div class="card-body">
                  <div class="customer-info">
                    <span *ngIf="customer.houseNumber">
                      {{ customer.houseNumber }},
                    </span>
                    {{ customer.shipToAddress?.street }},
                    {{ customer.shipToAddress?.city }},
                    {{ customer.shipToAddress?.state }},
                    {{ customer.shipToAddress?.postalCode }},
                    {{ customer.shipToAddress?.country }}
                  </div>

                  <div class="ids-row">
                    <div class="ship-to-sold-to">
                      <span class="label">Ship to:</span>
                      <span class="value">{{ customer.shipToNumber }}</span>
                    </div>

                    <div class="ship-to-sold-to">
                      <span class="label">Sold to:</span>
                      <span class="value">{{ customer.orders?.length ? customer.orders[0].soldToNumber : '' }}</span>
                    </div>
                  </div>
                </div>

                <div class="card-footer">
                  <img src="/assets/newimages/vieworders.png" (click)="viewOrders(customer)" />
                </div>
              </div>
            </div>

            <div class="no-customers" *ngIf="!isBusy && pagedData?.length === 0">
              No matching records found
            </div>
          </div>
        </div>

        <!-- ===== LIST VIEW ===== -->
        <div class="customers-scroll" *ngIf="viewMode === 'list'">
          <div class="container">
            <div class="list-table">
              <div class="list-header">
                <div>Customer Location</div>
                <div>Sold To</div>
                <div>Ship To</div>
                <div></div>
              </div>
              <div *ngFor="let customer of pagedData" class="list-row">
                <div>
                  <div class="name">{{ customer.orders?.length ? customer.orders[0].shipToName : '' }}</div>
                  <div class="address">
                    <span *ngIf="customer.houseNumber">
                      {{ customer.houseNumber }},
                    </span>
                    {{ customer.shipToAddress?.street }},
                    {{ customer.shipToAddress?.city }},
                    {{ customer.shipToAddress?.state }},
                    {{ customer.shipToAddress?.postalCode }},
                    {{ customer.shipToAddress?.country }}
                  </div>
                </div>

                <div class="center">{{ customer.orders?.length ? customer.orders[0].soldToNumber : '' }}</div>
                <div class="center">{{ customer.shipToNumber }}</div>

                <div class="action">
                  <span class="link" (click)="viewOrders(customer)">
                    View Orders
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="no-customers" *ngIf="!isBusy && pagedData.length === 0">
            No customers found.
          </div>
        </div>

        <!-- ===== PAGINATION ===== -->
        <div class="pagination-bar" *ngIf="totalItems > 0">
          <div class="container pagination-content">
            <span class="mobile-items-label">Items per page</span>

            <select [(ngModel)]="pageSize" (change)="onPageSizeChange($event)">
              <option [value]="10">10</option>
              <option [value]="25">25</option>
              <option [value]="50">50</option>
              <option [value]="100">100</option>
            </select>

            <span>{{ paginationRange }}</span>

            <button (click)="goToFirstPage()" [disabled]="pageIndex === 0">
              <img src="assets/newimages/pg-first.png">
            </button>

            <button (click)="prevPage()" [disabled]="pageIndex === 0">
              <img src="assets/newimages/pg-second.png">
            </button>

            <button (click)="nextPage()" [disabled]="isLastPage()">
              <img src="assets/newimages/pg-third.png">
            </button>

            <button (click)="goToLastPage()" [disabled]="isLastPage()">
              <img src="assets/newimages/pg-fourth.png">
            </button>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- ================= SEARCH TAB ================= -->
    <ng-container *ngIf="activeTab === 'search'">
      <div class="search-host" [ngClass]="{ 'no-bg': activeTab === 'search' }">
      <app-non-territory-dashboard [embedded]="true"></app-non-territory-dashboard>
      </div>
    </ng-container>
  </div>
</app-layout>
